import { handleJsonResponse, requestGet, requestPut, SERVICE_URL } from 'util/request';

import { JobType } from './types';

export const fetchJobs = (operationId: number) =>
  requestGet(`${SERVICE_URL}/jobs/${operationId}`).then(handleJsonResponse);

export const updateJob = (id: number, body: JobType) =>
  requestPut(`${SERVICE_URL}/job/${id}`, { body }).then(handleJsonResponse);
